import React, {PropTypes, Component} from 'react';
import ReactMarkdown from 'react-markdown';
import { Scrollspy } from 'react-scrollspy';
import {connect} from 'react-redux';
import { get, merge, omit, set } from 'lodash';
import IconButton from 'material-ui/IconButton';

import * as ui from '../../../redux/actionCreators/sync/ui';
import * as guideApi from '../../../redux/actionCreators/async/guides';

import Button from  '../../../common/components/Button';
import EditIcon from '../../../common/svgs/EditIcon';
import Logo from '../../../common/svgs/Logo';
import EditGuide from './edit';

@connect(store => ({
  showSnackBar: ui.showSnackBar,
  user: store.user
}))
export default class ViewGuide extends Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.any,
    user: PropTypes.object
  }

  constructor() {
    super();
    this.state = {
      content : null,
      navigation : null,
      edit : null
    };
  }

  componentDidMount() {
    this.refreshGuide();
  }

  refreshGuide() {
    this.props.dispatch(guideApi.getGuide((err, guide) => {
      this.setState({edit: null, ...guide});
    }));
  }

  saveGuide() {
    this.props.dispatch(guideApi.saveGuide(this.state))
      .then(guide => this.setState({edit: null, ...guide}))
    ;
  }

  newState() {
    return merge({}, this.state);
  }

  handleEdit(property) {
    return () => {
      const newState = this.newState();
      newState.edit = property;
      this.setState(newState);
    };
  }

  handleUpdate(property) {
    return (event, value) => {
      const newState = this.newState();
      set(newState, property, value);
      this.setState(newState);
    };
  }

  handleCloseModal() {
    return () => {
      this.refreshGuide();
    };
  }

  handleSave() {
    return () => {
      this.saveGuide();
    };
  }

  renderEditModal(state, props) {
    return (
      !!state.edit &&
      <EditGuide
        source={get(state, state.edit)}
        onUpdate={this.handleUpdate(state.edit)}
        onClose={this.handleCloseModal()}
        onSave={this.handleSave()}
      />
    );
  }

  renderEditButton(state, props, property) {
    if (get(props, 'user.roles', []).includes('Admin')) {
      return (
        <div className={`button-edit ${property}`}>
          <IconButton
             data-id={`edit-${property}`}
             tooltip={`Edit ${property}`}
             onClick={this.handleEdit(property)} >
             <EditIcon />
          </IconButton>
        </div>
      );
    }
  }

  renderContainer(state, props) {

    return (
        <div className='guide-page'>

          <div className='guide-navigation'>
            <div className='guide-navigation-container'>
              <Logo className='resume-logo' />
              {
                this.renderEditButton(state, props, 'navigation')
              }
              <ReactMarkdown
                source={state.navigation}
                escapeHtml={false}
              />
            </div>
          </div>

          <div className='guide-container'>
            {
              this.renderEditButton(state, props, 'content')
            }
            <ReactMarkdown
              source={state.content}
              escapeHtml={false}
            />
          </div>
          {
            this.renderEditModal(state, props)
          }
        </div>
    );

  }

  render() {
    const {
      state,
      props
    } = this;

    return this.renderContainer(state, props);
  }

}



// WEBPACK FOOTER //
// ./shared/react/admin/Guide/view.js